import { render, staticRenderFns } from "./IncomeInformation.vue?vue&type=template&id=58a607c6&scoped=true"
import script from "./IncomeInformation.vue?vue&type=script&lang=js"
export * from "./IncomeInformation.vue?vue&type=script&lang=js"
import style0 from "./IncomeInformation.vue?vue&type=style&index=0&id=58a607c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a607c6",
  null
  
)

export default component.exports